/**
 * @typedef {Object} CountyOption
 * @property {string} name - The display name of the Florida county
 * @property {string} value - The internal value/identifier for the county
 */

/**
 * Frozen array of Florida county options for use in dropdown selections.
 * Contains all 67 counties in Florida with their display names and corresponding values.
 * The array is frozen to prevent accidental modifications.
 * 
 * @type {ReadonlyArray<CountyOption>}
 * @constant
 * @example
 * // Usage in a dropdown component
 * FloridaCountyOptions.map(county => (
 *   <option key={county.value} value={county.value}>
 *     {county.name}
 *   </option>
 * ))
 */
export default Object.freeze([
    { name: "Alachua County", value: "Alachua" },
    { name: "Baker County", value: "Baker" },
    { name: "Bay County", value: "Bay" },
    { name: "Bradford County", value: "Bradford" },
    { name: "Brevard County", value: "Brevard" },
    { name: "Broward County", value: "Broward" },
    { name: "Calhoun County", value: "Calhoun" },
    { name: "Charlotte County", value: "Charlotte" },
    { name: "Citrus County", value: "Citrus" },
    { name: "Clay County", value: "Clay" },
    { name: "Collier County", value: "Collier" },
    { name: "Columbia County", value: "Columbia" },
    { name: "DeSoto County", value: "De_Soto" },
    { name: "Dixie County", value: "Dixie" },
    { name: "Duval County", value: "Duval" },
    { name: "Escambia County", value: "Escambia" },
    { name: "Flagler County", value: "Flagler" },
    { name: "Franklin County", value: "Franklin" },
    { name: "Gadsden County", value: "Gadsden" },
    { name: "Gilchrist County", value: "Gilchrist" },
    { name: "Glades County", value: "Glades" },
    { name: "Gulf County", value: "Gulf" },
    { name: "Hamilton County", value: "Hamilton" },
    { name: "Hardee County", value: "Hardee" },
    { name: "Hendry County", value: "Hendry" },
    { name: "Hernando County", value: "Hernando" },
    { name: "Highlands County", value: "Highlands" },
    { name: "Hillsborough County", value: "Hillsborough" },
    { name: "Holmes County", value: "Holmes" },
    { name: "Indian River County", value: "Indian_River" },
    { name: "Jackson County", value: "Jackson" },
    { name: "Jefferson County", value: "Jefferson" },
    { name: "Lafayette County", value: "Lafayette" },
    { name: "Lake County", value: "Lake" },
    { name: "Lee County", value: "Lee" },
    { name: "Leon County", value: "Leon" },
    { name: "Levy County", value: "Levy" },
    { name: "Liberty County", value: "Liberty" },
    { name: "Madison County", value: "Madison" },
    { name: "Manatee County", value: "Manatee" },
    { name: "Marion County", value: "Marion" },
    { name: "Martin County", value: "Martin" },
    { name: "Miami-Dade County", value: "Dade" },
    { name: "Monroe County", value: "Monroe" },
    { name: "Nassau County", value: "Nassau" },
    { name: "Okaloosa County", value: "Okaloosa" },
    { name: "Okeechobee County", value: "Okeechobee" },
    { name: "Orange County", value: "Orange" },
    { name: "Osceola County", value: "Osceola" },
    { name: "Palm Beach County", value: "Palm_Beach" },
    { name: "Pasco County", value: "Pasco" },
    { name: "Pinellas County", value: "Pinellas" },
    { name: "Polk County", value: "Polk" },
    { name: "Putnam County", value: "Putnam" },
    { name: "Santa Rosa County", value: "Santa_Rosa" },
    { name: "Sarasota County", value: "Sarasota" },
    { name: "Seminole County", value: "Seminole" },
    { name: "St. Johns County", value: "St_Johns" },
    { name: "St. Lucie County", value: "St_Lucie" },
    { name: "Sumter County", value: "Sumter" },
    { name: "Suwannee County", value: "Suwanee" },
    { name: "Taylor County", value: "Taylor" },
    { name: "Union County", value: "Union" },
    { name: "Volusia County", value: "Volusia" },
    { name: "Wakulla County", value: "Wakulla" },
    { name: "Walton County", value: "Walton" },
    { name: "Washington County", value: "Washington" }
]);